import React from "react";
import { getTournamentTitle, getTournamentType } from "../../../utils/tournamentUtils";
import classNames from 'classnames';
import { Button, Media, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import closeImg from '../../../images/icons/close.png';
import { useTranslation } from "react-i18next";
import CustomDate from "../UI/CustomDate";

function TournamentInfo({tournamentInfoModalOpen, closeTournamentInfoModal, selectTournament, fontMode}) {
    const { t } = useTranslation(['common']);

    return (
        <Modal container={'div > div'} size="lg" isOpen={tournamentInfoModalOpen} toggle={closeTournamentInfoModal} className={`old-modal root-font-${fontMode}`}>
            <ModalHeader
                toggle={closeTournamentInfoModal}
                close={
                    <Media src={closeImg} className="notification-header-close" alt="X" onClick={closeTournamentInfoModal} />
                }
            >
                {getTournamentTitle(selectTournament)}
            </ModalHeader>
            <ModalBody>
                <div className="tournament-info-section">
                    <div className={classNames('tournament-info-section-main', {})}>
                        {(selectTournament?.sponsorImg || selectTournament?.prizeImg) && (
                            <div className="tournament-info-section-main-row">
                                <div className="d-flex justify-content-center w-100">
                                    {selectTournament?.sponsorImg && (
                                        <div className="tournament-info-section-main-row-image-container">
                                            <span>{t('tournaments.sponsorTournaments')}</span>
                                            <Media className="" src={selectTournament?.sponsorImg} alt="x" />
                                        </div>
                                    )}
                                    {selectTournament?.prizeImg && (
                                        <div className="tournament-info-section-main-row-image-container">
                                            <span>{t('tournaments.mainPrize')}</span>
                                            <Media className="" src={selectTournament?.prizeImg} alt="x" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.gameType')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50 first-capitial">
                                { getTournamentType(selectTournament, t) }
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.bet')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.bet}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.joiningFee')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.entryFee}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.bonus')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.bonus}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.intervalBetweenRounds')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.newRoundPause} ${t('tournaments.minutes')}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.numberOfRounds')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.rounds}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.numberOfGamesPerRound')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.roundLength}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.startOfTournament')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                <CustomDate format="DD.MM.YYYY hh:mm" date={selectTournament?.startDate} />
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.startOfRegistration')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                <CustomDate format="DD.MM.YYYY hh:mm" date={selectTournament?.startDate - (selectTournament?.registerTime * 1000 * 60)} />
                            </div>
                        </div>
                        {/** dont delete */}
                        {/* <div className="tournament-info-section-main-row">
                        <div className="tournament-info-section-main-row-content w-50">
                            {t('tournaments.maxNumOfPlayers')}
                        </div>
                        <div className="tournament-info-section-main-row-value w-50">
                            {`${selectTournament?.maxPlayers}`}
                        </div>
                        </div> */}
                        <div className='tournament-info-section-main-row'>
                            <div className='tournament-info-section-main-row-content w-50'>
                                {t('tournaments.playerPerRoomLimit')}
                            </div>
                            <div className='tournament-info-section-main-row-value w-50'>
                                {`${selectTournament?.playerPerRoomLimit ? (selectTournament.playerPerRoomLimit === 4 ? t('tournaments.playerPerRoomLimit4Only') : t('tournaments.playerPerRoomLimit3Only')) : t('tournaments.playerPerRoomLimitClasic')}`}
                            </div>
                        </div>
                        <div className="tournament-info-section-main-row">
                            <div className="tournament-info-section-main-row-content w-50">
                                {t('tournaments.winningPercent')}
                            </div>
                            <div className="tournament-info-section-main-row-value w-50">
                                {`${selectTournament?.winnerPercent}%`}
                            </div>
                        </div>
                        {selectTournament?.restrictions && (
                            <div className="tournament-info-section-main-row">
                                <div className={classNames('tournament-info-section-main-row-content w-50 active-tournaments-info-section-title-right history-tournaments-info-section-title-right')}>
                                    <div>{t(`common.restrictions`)}</div>
                                </div>
                                <div className="tournament-info-section-main-row-value w-50 d-flex flex-column">
                                    {selectTournament?.levelFrom && selectTournament?.levelTo && (
                                        <span>{`${t('common.level')}: ${selectTournament?.levelFrom}–${selectTournament?.levelTo}`}</span>
                                    )}
                                    {selectTournament?.pointsFrom && selectTournament?.pointsTo && (
                                        <span>{`${t('common.points')}: ${selectTournament?.pointsFrom}–${selectTournament?.pointsTo}`}</span>
                                    )}
                                    {selectTournament?.balanceFrom && selectTournament?.balanceTo && (
                                        <span>{`${t('common.balance')}: ${selectTournament?.balanceFrom}–${selectTournament?.balanceTo}`}</span>
                                    )}
                                    {selectTournament?.playedGamesFrom && selectTournament?.playedGamesTo && (
                                        <span>{`${t('common.playedGames')}: ${selectTournament?.playedGamesFrom}–${selectTournament?.playedGamesTo}`}</span>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="modal-footer-button" onClick={closeTournamentInfoModal}>{t('tournaments.close')}</Button>
            </ModalFooter>
        </Modal>
    );
}

export default TournamentInfo;